export class RegisterProviderRequest {
  public userName: string;
  public collectionID?: number;
  public calProviderID: string;
  public providerAddressType: string;
  public providerPositionID?: number;
  public providerPositionOther: string;
}
